import { useState } from 'react';

export default function TestimonialsSection() {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      location: 'Toorak, Melbourne',
      rating: 5,
      text: 'Absolutely incredible service! The team came to my office and transformed my BMW. The attention to detail was outstanding, and the convenience of mobile service is unmatched. Highly recommend Starlight Motors!',
      service: 'Full Detail & Ceramic Coating'
    },
    {
      name: 'James Chen',
      location: 'South Yarra, Melbourne',
      rating: 5,
      text: 'Professional, reliable, and the results speak for themselves. My Mercedes looks better than when I first bought it. The starlight headliner installation was absolutely stunning. Worth every dollar!',
      service: 'Headliner Installation'
    },
    {
      name: 'Emma Thompson',
      location: 'Brighton, Melbourne',
      rating: 5,
      text: 'The convenience factor is amazing - they came to my home while I worked. The team was punctual, professional, and my Audi has never looked better. The ceramic coating is incredible!',
      service: 'Ceramic Coating'
    }
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  return (
    <section id="testimonials" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-white mb-4">
            <strong>What Our Customers Say</strong>
          </h3>
          <p className="text-xl text-gray-300">
            Real reviews from satisfied customers across Melbourne
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          {/* Testimonial Slider */}
          <div className="overflow-hidden">
            <div 
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {testimonials.map((testimonial, index) => (
                <div key={index} className="w-full flex-shrink-0 px-4">
                  <div className="bg-gray-800 rounded-xl p-8 shadow-lg text-center max-w-2xl mx-auto border border-gray-700">
                    <div className="flex justify-center items-center mb-6">
                      <div className="flex text-yellow-400">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <i key={i} className="ri-star-fill text-2xl"></i>
                        ))}
                      </div>
                    </div>
                    
                    <p className="text-gray-300 mb-8 leading-relaxed text-lg">
                      "{testimonial.text}"
                    </p>
                    
                    <div className="border-t border-gray-700 pt-6">
                      <div className="font-semibold text-white text-xl mb-2">
                        <strong>{testimonial.name}</strong>
                      </div>
                      <div className="text-gray-400 mb-3">
                        {testimonial.location}
                      </div>
                      <div className="text-teal-400 font-medium">
                        {testimonial.service}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-gray-800 rounded-full p-3 shadow-lg hover:bg-gray-700 transition-colors duration-300 cursor-pointer border border-gray-700"
          >
            <i className="ri-arrow-left-line text-2xl text-white"></i>
          </button>
          
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-gray-800 rounded-full p-3 shadow-lg hover:bg-gray-700 transition-colors duration-300 cursor-pointer border border-gray-700"
          >
            <i className="ri-arrow-right-line text-2xl text-white"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center mt-8 space-x-3">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-colors duration-300 cursor-pointer ${
                  currentSlide === index ? 'bg-teal-500' : 'bg-gray-600'
                }`}
              />
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-6">
            <a 
              href="https://www.instagram.com/starlightmotors_/" 
              target="_blank" 
              rel="nofollow"
              className="flex items-center text-gray-400 hover:text-teal-400 transition-colors"
            >
              <i className="ri-instagram-line text-2xl mr-2"></i>
              <span>Follow us on Instagram</span>
            </a>
            <a 
              href="https://www.facebook.com/people/Starlightmotors-mobile-detailing/61573939679933/#" 
              target="_blank" 
              rel="nofollow"
              className="flex items-center text-gray-400 hover:text-teal-400 transition-colors"
            >
              <i className="ri-facebook-line text-2xl mr-2"></i>
              <span>Like us on Facebook</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
